import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-renderer-technician-subTask',
    template: `
    <style>
        .edit-btn {
            color: white;
            background: #3aafe4;
            margin-right: 5px;
        }
        .delete-btn {
            color: white;
            background: red;
            margin-right: 5px;
        }
        i {
            color: white;
            padding-bottom: 15px
        }
        .btn:disabled {
            opacity: 0.5;
        }
        .btn {
            padding: 7px 10px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
        }
        .d-flex {
            display: flex;
        }
    </style>
    <div class="d-flex">
        <button class="delete-btn btn custom-tooltip" *ngIf="isDelete" [disabled]="isButtonDisabled(params) || isCompleted" title="Delete" mat-icon-button tooltipPosition="top" (click)="onClickDelete($event)">
            <i class="fa fa-trash" aria-hidden="true"></i>
        </button>

        <button class="edit-btn btn custom-tooltip" *ngIf="isUpdate" [disabled]="isButtonDisabled(params) || isCompleted" title="Edit" mat-icon-button tooltipPosition="top" (click)="onClickEdit($event)">
            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </button>
    </div>
    `
})

export class ActionEditDeleteBtnRendererTechnicianSubTask implements ICellRendererAngularComp, OnDestroy {
    params: any;
    isUpdate: boolean = false;
    isDelete: boolean = false;
    isCompleted = false;
    isTechnicianScreen: boolean = false;
    // If you want to implement the refresh method
    refresh(params: any): boolean {
        // This will ensure the component re-renders if required
        return true;
    }

    agInit(params: any): void {
        this.params = params;
        this.isUpdate = params.isUpdate ?? false;
        this.isDelete = params.isDelete ?? false;
        this.isCompleted = params?.data?.status?.toLowerCase() === 'completed';
        this.isTechnicianScreen = params.isTechnicianScreen ?? false;
    }
    isButtonDisabled(params: any): boolean {
        return this.isTechnicianScreen && params?.data?.IsManager === true;
    }
    onClickEdit($event: any): void {
        if (this.params.onClickEdit instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickEdit(params);
        }
    }

    onClickDelete($event: any): void {
        if (this.params.onClickDelete instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickDelete(params);
        }
    }

    ngOnDestroy(): void {
        // Cleanup if necessary (optional)
    }
}
